// Legacy gamified styles — kept for secondary auth flows not yet migrated.
export { inputClassName, selectClassName } from '@/shared/ui/input-styles'

export const buttonClassName = 'h-[42px] text-md'

// ---------------------------------------------------------------------------
// Institutional auth identity (aligned with the landing — design §10).
// Local to features/auth — never touch @/shared/ui/{Button,input-styles,Card}.
// Surfaces render on a dark brand shell (AuthShell), so inputs/labels are light.
// ---------------------------------------------------------------------------

export const authInputClassName =
  'w-full h-11 rounded-xl border border-white/15 bg-white/5 px-3.5 text-white ' +
  'placeholder:text-white/40 transition-colors hover:border-white/25 ' +
  'focus-visible:border-primary focus-visible:ring-0 [color-scheme:dark]'

export const authCtaClassName =
  'inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-primary ' +
  'px-6 text-base font-extrabold text-primary-foreground cursor-pointer transition ' +
  'shadow-[0_5px_0_var(--color-primary-dark)] hover:-translate-y-0.5 hover:shadow-[0_7px_0_var(--color-primary-dark)] ' +
  'active:translate-y-0.5 active:shadow-[0_3px_0_var(--color-primary-dark)] ' +
  'disabled:pointer-events-none disabled:opacity-60'

export const authSecondaryClassName =
  'inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl border-2 border-white/20 ' +
  'bg-white/5 px-6 text-base font-bold text-white backdrop-blur cursor-pointer transition ' +
  'hover:bg-white/10'
